<template>
  <div class="my-title">
    <span>————</span>
    <b>
      <slot name="title"></slot>
    </b>
    <span>————</span>
    <p><slot name="subtitle"></slot></p>
  </div>
</template>

<script>
export default {
  name: "MyTitle"
}
</script>

<style scoped lang="less">
.my-title {
  text-align: center;

  span {
    display: inline-block;
    padding: 0 30px;
    color: #CCCCCC;
    font-size: 30px;
  }

  b {
    font-size: 30px;
    margin-bottom: 30px;

    i {
      color: #1E55AE;
      font-size: 70px;
    }
  }

  p {
    margin: auto;
    width: 650px;
    font-size: 12px;
    line-height: 24px;
    color: #BFBFBF;
  }
}
</style>